export default {"src":"/_next/static/media/logo_web_GNB_white.eb2ab8ef.svg","height":32,"width":85,"blurWidth":0,"blurHeight":0};